import { handleCallback } from './handleCallback'
import { loadCreateUser, loadCreateUserNull } from './loadCreateUser'
import { login, logout } from './loginLogout'
import { loadSession } from './session'
import { getAccessToken } from './token'
import { Auth, AuthSettings } from './types'

export const initAuth = async (authSettings: AuthSettings): Promise<Auth> => {
    await handleCallback(authSettings)

    const session = loadSession(authSettings)

    const result: Auth = {
        clientId: authSettings.clientId,
        userId: session ? session.userId : null,
        getAccessToken: session ? getAccessToken(authSettings) : () => Promise.resolve(null),
        login: session ? () => Promise.resolve() : login(authSettings),
        logout: session ? logout(authSettings, session) : () => Promise.resolve(),
        loadCreateUser: session ? loadCreateUser : loadCreateUserNull,
    }

    const { forceUser } = authSettings
    if (forceUser && result.login) {
        const currentUrl = new URL(window.location.href)
        const flow = currentUrl.pathname === '/auth/signup' ? 'signup' : undefined
        await result.login({
            returnTo: window.location.href,
            flow,
        })
    }

    return result
}
